import gql from "graphql-tag";

const SaveDownloadMutation = gql`
  mutation($document: ResourceInput) {
    saveDownload(document: $document)
  }
`;

export default SaveDownloadMutation;
